<template>
    <div class="main-container">

        <div class="main-container-title-box">
            <div class="main-container-title-box-text">
                <span class="title-box-text">
                    Котировки
                </span>
                <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false"
                    color="var(--app-dark-blue-1)">mdi-information</v-icon>
            </div>
        </div>

        <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
            <v-card min-width="300px" min-height="100px">
                <div class="menu-container">
                    <div class="menu-container-title">
                        «Котировки»
                    </div>
                    <div class="menu-container-text">
                        Блок с графиком котировок VTBR, можно скрывать при острой необходимости
                    </div>

                </div>

            </v-card>
        </v-menu>
        <div>

            <v-switch v-model="quotes" color="var(--app-green-1)" label="Отображать блок" style="margin-left: 24px"
                @change="changeQuotes"></v-switch>
        </div>
    </div>
</template>
<script>

export default {

    data: () => ({
        quotes: false,
        showInfo: false,
        x: null,
        y: null,
    }),
    created() {
        this.getStatus()
    },
    methods: {
        openInfo(e) {

            e.preventDefault()

            this.x = e.clientX + 10
            this.y = e.clientY + 10
            this.showInfo = true
        },
        changeQuotes() {

            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/settings/quotes', {

                status: this.quotes ? 'enabled' : 'disabled'

            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(() => {



                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        getStatus() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/settings/quotes', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(res => {

                    if (res.data.value === 'disabled') {

                        this.quotes = false
                    }
                    else if (res.data.value === 'enabled') {

                        this.quotes = true
                    }
                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        }

    },
}
</script>
<style lang="scss" scoped></style>